"use client";
import * as React from "react";
import Div100vh from "react-div-100vh";
import classNames from "classnames";
import { useTranslation } from "next-i18next";

import Button from "@/components/Button";
import styles from "./styles.module.scss";
import { endLoadingState } from "@/utils/loading";
import { isServer } from "@/utils/helpers";

interface ErrorScreenPropsType {
  resetError(): void;
}

export function onReset(): void {
  if (!isServer()) {
    window.location.reload();
  }
}
export function onError(
  error: unknown,
  componentStack: string,
  eventId: string
) {
  console.error(error, componentStack);
  console.error(eventId);
}

export function ErrorScreen({ resetError }: ErrorScreenPropsType) {
  const { t } = useTranslation();

  React.useEffect(() => {
    endLoadingState();
  }, []);

  return (
    <Div100vh className="flex flex-col justify-center items-center text-center">
      <h1 className={classNames(styles.title, "mb-4")}>
        {t("Leider ist etwas schief gelaufen")}
      </h1>
      <p className={classNames(styles.subtitle, "mb-4")}>
        {t("Es ist ein Fehler aufgetreten, bitte laden Sie die Seite neu.")}
      </p>
      <Button onClick={resetError}>{t("Neu laden")}</Button>
    </Div100vh>
  );
}
